import { RequiredPlugin } from "@/types/elements";

export const emptyHtmlFromSsrMessage = `
<div class="breakdance-empty-ssr-message">
    This element has no content.

    <small>Hide this notice at <i>Preferences / UI Settings / Disable Notice For Empty SSR Elements</i></small>
</div>`;

export const ssrErrorMessage = `
<div class="breakdance-empty-ssr-message breakdance-empty-ssr-message-error">
    There was an error on the server when rendering this element.
</div>`;

export const requiredPluginsNotAvailableMessage = (
  elementName: string,
  requiredPlugins: RequiredPlugin[]
) => {
  return `
<div class="breakdance-empty-ssr-message breakdance-empty-ssr-message-error">
    The <strong>"${elementName}"</strong> element requires the plugins <em>"${requiredPlugins.join(
    ", "
  )}"</em>. Please check that they are installed and activated from the Plugins page of the WP admin.
</div>`;
};
